import { Routes } from '@angular/router';
import { AuthModuleGuard, RouteManagementService } from '@draeger-academy/common';
import { LoginModuleGuard } from '@draeger-academy/common/lib/guards/login-module.guard';
import { PreviewManagementService } from '@draeger-academy/common/lib/services/preview-management/preview-management.service';
import { CountrySelectionComponent } from '../../views/country-selection/country-selection.component';
import { PageNotFoundComponent } from '../../views/page-not-found/page-not-found.component';
import { ServerErrorPageComponent } from '../../views/server-error-page/server-error-page.component';

export const routes: Routes = [
    {
        path: 'home',
        loadChildren: () => import('../../views/home/home.module').then((m) => m.HomeModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'courses',
        loadChildren: () => import('../../views/courses/courses.module').then((m) => m.CoursesModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'booking',
        loadChildren: () => import('../../views/booking/booking.module').then((m) => m.BookingModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'checkout',
        loadChildren: () => import('../../views/booking-steps/booking-steps.module').then((m) => m.BookingStepsModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'booking-details',
        loadChildren: () => import('../../views/user/booking-details/booking-details.module').then((m) => m.BookingDetailsModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'course',
        loadChildren: () => import('../../views/course/course.module').then((m) => m.CourseModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'event',
        loadChildren: () => import('../../views/event/event.module').then((m) => m.EventModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'general-terms',
        loadChildren: () => import('../../views/legal/general-terms-page/general-terms-page.module').then((m) => m.GeneralTermsModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'legal-notice',
        loadChildren: () => import('../../views/legal/legal-notice/legal-notice.module').then((m) => m.LegalNoticeModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'notice',
        loadChildren: () => import('../../views/legal/notice/notice.module').then((m) => m.NoticeModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'transparency',
        loadChildren: () => import('../../views/legal/transparency/transparency.module').then((m) => m.TransparencyModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'licenses',
        loadChildren: () => import('../../views/legal/licenses/licenses.module').then((m) => m.LicenseseModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'terms-and-conditions-of-sale',
        loadChildren: () =>
            import('../../views/legal/terms-and-conditions-of-sale/terms-and-conditions-of-sale.module').then(
                (m) => m.TermsAndConditionsOfSaleModule
            ),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'supplier-indentification',
        loadChildren: () =>
            import('../../views/legal/supplier-indentification/supplier-indentification.module').then(
                (m) => m.SupplierIndentificationModule
            ),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'contact-us',
        loadChildren: () => import('../../views/contact-us/contact-us.module').then((m) => m.ContactUsModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'data-protection',
        loadChildren: () => import('../../views/legal/data-protection/data-protection.module').then((m) => m.DataProtectionModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'personal-data',
        loadChildren: () => import('../../views/user/personal-data/personal-data.module').then((m) => m.PersonalDataModule),
        canActivate: [RouteManagementService, PreviewManagementService, AuthModuleGuard]
    },
    {
        path: 'my-courses',
        loadChildren: () => import('../../views/user/courses/courses.module').then((m) => m.CoursesModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'landing',
        loadChildren: () => import('../../views/user/landing/landing.module').then((m) => m.LandingModule),
        canActivate: [RouteManagementService, PreviewManagementService, AuthModuleGuard]
    },
    {
        path: 'server-error-page',
        component: ServerErrorPageComponent,
        canActivate: [RouteManagementService]
    },
    {
        path: 'search',
        loadChildren: () => import('../../views/search-page/search-page.module').then((m) => m.SearchPageModule),
        canActivate: [RouteManagementService]
    },
    {
        path: 'countryselection',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true
        }
    },
    {
        path: 'generalterms',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isGeneralTerms: true
        }
    },
    {
        path: 'dataprotection',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isDataProtection: true
        }
    },
    {
        path: 'legalnotice',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isLegalNotice: true
        }
    },
    {
        path: 'noticeselection',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isNotice: true
        }
    },
    {
        path: 'transparencyselection',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isTransparency: true
        }
    },
    {
        path: 'termsandconditionsofsaleselection',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isTermsAndConditionsOfSale: true
        }
    },
    {
        path: 'licensesselection',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isLicenses: true
        }
    },
    {
        path: 'supplieridentification',
        component: CountrySelectionComponent,
        data: {
            skipRouteLocalization: true,
            isSupplierIndentification: true
        }
    },

    {
        path: 'login',
        loadChildren: () => import('../../views/user/login/login.module').then((m) => m.LoginModule),
        canActivate: [RouteManagementService, PreviewManagementService, LoginModuleGuard]
    },
    {
        path: 'change-password',
        loadChildren: () => import('../../views/user/change-password/change-password.module').then((m) => m.ChangePasswordModule),
        canActivate: [RouteManagementService, PreviewManagementService, AuthModuleGuard]
    },
    {
        path: 'partner',
        pathMatch: 'full',
        component: PageNotFoundComponent
    },
    {
        path: 'partner/:portalId',
        loadChildren: () => import('../../views/partner-portal/portal-app.module').then((m) => m.PortalAppModule),
        data: {
            skipRouteLocalization: true,
            feature: 'Partner'
        }
    },
    {
        path: 'training-advisor',
        loadChildren: () => import('../../views/training-advisor/training-advisor.module').then((m) => m.TrainingAdvisorModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'booking-error',
        loadChildren: () => import('../../views/booking-error/booking-error.module').then((m) => m.BookingErrorModule),
        canActivate: [RouteManagementService, PreviewManagementService]
    },
    {
        path: 'payment-success',
        loadChildren: () =>
            import('../../views/booking-successful-payment/booking-successful-payment.module').then(
                (m) => m.BookingSuccessfulPaymentModule
            ),
        canActivate: [RouteManagementService, PreviewManagementService]
    },

    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent }
];
